import axios from '@/http/axios';
import {route} from '@/http/ziggy';

/**
 * Will tell us if there is a consent form available for this mode.
 *
 * @param {Number} user
 * @param {String} mode
 *
 * @return {Promise}
 */
export const show = (user, mode) => axios.get(route('app.mode.consent_form.check', {user, mode}));

/**
 * User giving consent to form.
 *
 * @param {Number} user
 * @param {Number} consentForm
 * @param {Boolean} consent
 *
 * @return {Promise}
 */
export const giveConsentTo = (user, consentForm, consent) => axios.put(route('app.mode.consent_form.give_consent', {user, consentForm}), {consent});